































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { getCurrentTimezoneOffsetMs } from '@/utils/tool';

/**
 * 时长输入组件
 *
 * @author liyuyao
 * @date 04/08/2020
 */
const baseTime = getCurrentTimezoneOffsetMs();

@Component
export default class DayTimeSlot extends Vue {
    @Prop({ default: 5 })
    timeSlots: number[][];

    @Prop({ default: false })
    disabled: boolean;
    @Prop({ default: true })
    isRequired: boolean;

    timsSlotsValue: number[][] = [[0, 0]];

    @Watch('timeSlots', { immediate: true })
    getTimeSlots(timeSlots) {
        if (timeSlots.length) {
            this.timsSlotsValue = timeSlots.map(time => {
                return time.map(item => new Date(item - baseTime));
            });
        }
    }
    getMillisecond(date) {
        if (date) {
            const hour = date.getHours();
            const min = date.getMinutes();
            return (hour * 3600 + min * 60) * 1000;
        } else {
            return 0;
        }
    }
    emitTimeChange() {
        this.$emit('change', this.formatEmitValue);
    }
    deleteTimeSlot(index) {
        this.timsSlotsValue.splice(index, 1);
        this.$emit('change', this.formatEmitValue);
    }
    AddTimeSlot() {
        this.timsSlotsValue.push([null, null]);
    }
    get formatEmitValue() {
        return this.timsSlotsValue.map(time => {
            return time.map(item => this.getMillisecond(item));
        });
    }
    computeErrorTip(timeSlot) {
        if (this.disabled) {
            return '';
        }
        if (this.isRequired && (!timeSlot || timeSlot.length < 2 || !timeSlot[0] || !timeSlot[1])) {
            return '请选择时间段';
        } else if (timeSlot[0] > timeSlot[1]) {
            return '开始时间需要早于结束时间';
        } else {
            return '';
        }
    }
}
